var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "overlay" }, [
      _c("div", { staticClass: "img-style edit-button" }, [
        _c("img", {
          attrs: { src: require("@/assets/meal_history/アセット 20@2x.png") },
          on: { click: _vm.back }
        }),
        _vm._v(" "),
        _c("img", {
          attrs: { src: require("@/assets/meal_history/アセット 21@2x.png") },
          on: { click: _vm.pushedRecord }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eb6346c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb6346c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/molecules/InputEditWater.vue
// module id = null
// module chunks = 